/*
 * Enumerador que contém os tipos de autenticação disponíveis. 
 */

export enum AuthenticationTypes {
  Email = 'Email',
  App = 'Google Authenticator', // Será alterado no back
}
